import isDev from "./utils/isDev";

const ORG_PATH_PLACEHOLDER = "[org]";

/**
 * Indicates whether we should pass a "dev" query param
 * to Framer to distinguish between the dev and prod
 * environments.
 */
const ORGS_LANDING_PAGE_ENV = isDev() ? "?dev=true" : "";

/**
 * Currently hosted in Framer.
 */
export const ORGS_LANDING_PAGE = `https://orgs.quira.sh${ORGS_LANDING_PAGE_ENV}`;

const routes = {
  AUTH_CALLBACK: "/_callback",
  DISCORD_AUTH_CALLBACK: "/discord-auth-callback",
  REPO: "/repo/:urlString",
  SETTINGS: "/settings",
  PROFILE: "/user",
  DASHBOARD: "/dashboard",
  CONTRIBUTE: "/contribute",
  BOOKMARKS: "/bookmarks",
  NOT_FOUND: "/404",
  WEB3_REPOS: "/web3-repos",
  REPOVERSE: "/repoverse",
  TODO_LIST: "/todo-list",
  HACKTOBERFEST: "/hacktoberfest",
  // AWQ Organisation Routes
  AWQ_BUTTON: "/awq/:orgId",
  AWQ_APPLY: "/apply",
  RECRUIT_OPEN_POSITIONS: "/recruit/open-positions",
  RECRUIT_CLOSED_POSITIONS: "/recruit/closed-positions",
  RECRUIT_ADD_POSITION: "/recruit/add-position",
  RECRUIT_EDIT_POSITION: "/recruit/edit-position",
  RECRUIT_ORGANIZATION: "/recruit/organization",
  RECRUIT_ORGANIZATION_SHOW: "/recruit/organization/[urlString]",

  ONBOARDING: "/onboarding",
  ONBOARDING_AFTER_SIGNUP: "/onboarding/2",
  HOME: "/",
  STATS: "/stats",
  LEADERBOARDS: "/leaderboards",
  CREATOR_STATS: "/creator-stats",

  // Quests routes
  QUESTS_WELCOME: "/organisations/welcome",
  QUESTS_ALL: "/organisations/[org]/quests/s",
  QUESTS_DETAILS: "/organisations/[org]/quests/s/details",
  QUESTS_CREATE_QUEST: "/organisations/[org]/quests/start-quest",
  QUESTS_ALL_DEFAULT: "/organisations/_/quests/s",
  QUEST: "/organisations/[org]/quests/s/[slug]",
  ORG: "/org/[orgName]",
  CREATOR_QUESTS_HOME: "/quests/creator",
  CREATOR_QUESTS_SUBMISSIONS: "/quests/creator/submissions",
  CREATOR_QUESTS_DETAILS: "/quests/creator/details",
  CREATOR_QUESTS_SPONSORS: "/quests/creator/sponsors",
  CREATOR_QUESTS_SUBMIT: "/quests/creator/submit",
  CREATOR_QUESTS_EDIT_SUBMISSION: "/quests/creator/edit",
  CONTRIBUTOR_QUESTS: "/quests/solver",
  CONTRIBUTOR_QUESTS_JOIN: "/quests/solver/join",
  CONTRIBUTOR_QUEST_EMBARK: "/quests/solver/[ghIssueId]",

  // Sanity routes
  BLOG_HOME: "/blog",
  BLOG_HOME_ARTICLES: "/blog/articles",
  BLOG_HOME_RELEASES: "/blog/releases",
  BLOG_HOME_CASE_STUDIES: "/blog/case-studies",
  BLOG_POST: "/blog/[slug]",
  BLOG_STUDIO: "/studio",
  BLOG_PREVIEW: "/api/blog/preview",
  BLOG_PREVIEW_EXIT: "/api/blog/exit-preview",
};

export const settingsRoutes = {
  ABOUT_YOU: "/about-you",
  ACCOUNTS: "/accounts",
  PUBLIC_PROFILE: "/public-profile",
};

export const LOGIN_METHOD = "login-with-github";

export const apiRoutes = {
  AUTH_LOGOUT: "/api/auth/logout",
  AUTH_ACCESS_TOKEN: "/api/auth/access-token",
  AUTH_LOGIN: `/api/auth/${LOGIN_METHOD}`,
};

export const getDefaultRedirect = (orgName?: string) => {
  // if (orgName) {
  //   return routes.QUESTS_ALL_DEFAULT.replace("_", orgName);
  // }
  // Fallback to the default route if no org name is provided
  return `/settings/${settingsRoutes.ABOUT_YOU}`;
};

export const getDefaultAdminRedirect = (orgName: string) => {
  return routes.QUESTS_ALL.replace(ORG_PATH_PLACEHOLDER, orgName);
};

export const getLandingPageRedirect = (
  userOrgName: string | undefined
): string => {
  // Send user to the developer dashboard.
  // if (userOrgName) return getDefaultAdminRedirect(userOrgName);
  // Send user to the org admin dashboard.
  return getDefaultRedirect();
};

export default routes;
